// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #0a0a0a;
  color: #ffffff;
}

.App {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.navbar {
  background: linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%);
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 20px rgba(0, 255, 136, 0.1);
  border-bottom: 1px solid #333;
}

.navbar-brand {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.navbar-logo {
  height: 50px;
  width: 50px;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.navbar h1 {
  font-size: 2rem;
  background: linear-gradient(135deg, #00ff88 0%, #00ccff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-shadow: 0 0 30px rgba(0, 255, 136, 0.5);
}

.nav-bar,
.nav-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  padding: 1rem 2rem;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  flex-wrap: wrap;
}

.nav-bar button,
.nav-buttons button {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #ffffff;
  padding: 0.5rem 1.5rem;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

.nav-buttons button:hover {
  background: rgba(0, 255, 136, 0.1);
  border-color: rgba(0, 255, 136, 0.3);
  transform: translateY(-2px);
  box-shadow: 0 4px 20px rgba(0, 255, 136, 0.2);
}

.nav-bar button.active,
.nav-buttons button.active {
  background: linear-gradient(135deg, rgba(0, 255, 136, 0.2) 0%, rgba(0, 204, 255, 0.2) 100%);
  border-color: rgba(0, 255, 136, 0.5);
  box-shadow: 0 0 20px rgba(0, 255, 136, 0.3);
}

.employee-access-btn {
  background: rgba(255, 162, 0, 0.15) !important;
  border-color: rgba(255, 162, 0, 0.4) !important;
  color: #ffa500 !important;
}

.employee-access-btn:hover {
  background: rgba(255, 162, 0, 0.25) !important;
  border-color: #ffa500 !important;
  box-shadow: 0 0 20px rgba(255, 162, 0, 0.3) !important;
}


.main-content {
  flex: 1 1;
  padding: 2rem;
  background-color: #0a0a0a;
  position: relative;
  overflow-y: auto;
}

.main-content::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    radial-gradient(circle at 20% 50%, rgba(0, 255, 136, 0.05) 0%, transparent 50%),
    radial-gradient(circle at 80% 50%, rgba(0, 204, 255, 0.05) 0%, transparent 50%);
  pointer-events: none;
  z-index: 0;
}


.main-content > * {
  position: relative;
  z-index: 1;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(0, 255, 136, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(0, 255, 136, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(0, 255, 136, 0);
  }
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.message {
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: 1rem;
  animation: slideIn 0.3s ease;
  font-weight: 500;
}

.message.success {
  background: rgba(0, 255, 136, 0.1);
  border: 1px solid rgba(0, 255, 136, 0.3);
  color: #00ff88;
}

.message.error {
  background: rgba(255, 0, 0, 0.1);
  border: 1px solid rgba(255, 0, 0, 0.3);
  color: #ff4444;
}

.app-footer {
  background: linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%);
  border-top: 1px solid #333;
  padding: 1rem 2rem;
  margin-top: auto;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1400px;
  margin: 0 auto;
}

.club-name {
  font-weight: 600;
  background: linear-gradient(135deg, #00ff88 0%, #00ccff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.created-by {
  font-size: 0.9rem;
  color: #888;
  font-style: italic;
}

@media (max-width: 768px) {
  .navbar {
    flex-direction: column;
    padding: 1rem;
    gap: 1rem;
  }

  .navbar-brand {
    width: 100%;
    justify-content: center;
  }

  .navbar-logo {
    height: 40px;
    width: 40px;
  }

  .navbar h1 {
    font-size: 1.5rem;
  }

  .nav-buttons {
    width: 100%;
    justify-content: center;
    flex-wrap: wrap;
  }

  .nav-buttons button {
    padding: 0.4rem 1rem;
    font-size: 0.9rem;
  }
}

@media (max-width: 480px) {
  .navbar-logo {
    height: 35px;
    width: 35px;
  }

  .navbar h1 {
    font-size: 1.2rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6CAA6C;EAC7C,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;;EAEE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,8BAA8B;EAC9B,2BAA2B;EAC3B,iDAAiD;EACjD,eAAe;AACjB;;AAEA;;EAEE,qCAAqC;EACrC,0CAA0C;EAC1C,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;;EAEE,2FAA2F;EAC3F,oCAAoC;EACpC,2CAA2C;AAC7C;;AAEA;EACE,8CAA8C;EAC9C,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA;EACE,8CAA8C;EAC9C,gCAAgC;EAChC,sDAAsD;AACxD;;;AAGA;EACE,SAAO;EACP,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;mFAEiF;EACjF,oBAAoB;EACpB,UAAU;AACZ;;;AAGA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE;IACE,0CAA0C;EAC5C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE;IACE,sBAAsB;IACtB,aAAa;IACb,SAAS;EACX;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: #0a0a0a;\n  color: #ffffff;\n}\n\n.App {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.navbar {\n  background: linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%);\n  padding: 1rem 2rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  box-shadow: 0 2px 20px rgba(0, 255, 136, 0.1);\n  border-bottom: 1px solid #333;\n}\n\n.navbar-brand {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.navbar-logo {\n  height: 50px;\n  width: 50px;\n  object-fit: contain;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);\n}\n\n.navbar h1 {\n  font-size: 2rem;\n  background: linear-gradient(135deg, #00ff88 0%, #00ccff 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  text-shadow: 0 0 30px rgba(0, 255, 136, 0.5);\n}\n\n.nav-bar,\n.nav-buttons {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  padding: 1rem 2rem;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(10px);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  flex-wrap: wrap;\n}\n\n.nav-bar button,\n.nav-buttons button {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: #ffffff;\n  padding: 0.5rem 1.5rem;\n  border-radius: 8px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  backdrop-filter: blur(10px);\n}\n\n.nav-buttons button:hover {\n  background: rgba(0, 255, 136, 0.1);\n  border-color: rgba(0, 255, 136, 0.3);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 20px rgba(0, 255, 136, 0.2);\n}\n\n.nav-bar button.active,\n.nav-buttons button.active {\n  background: linear-gradient(135deg, rgba(0, 255, 136, 0.2) 0%, rgba(0, 204, 255, 0.2) 100%);\n  border-color: rgba(0, 255, 136, 0.5);\n  box-shadow: 0 0 20px rgba(0, 255, 136, 0.3);\n}\n\n.employee-access-btn {\n  background: rgba(255, 162, 0, 0.15) !important;\n  border-color: rgba(255, 162, 0, 0.4) !important;\n  color: #ffa500 !important;\n}\n\n.employee-access-btn:hover {\n  background: rgba(255, 162, 0, 0.25) !important;\n  border-color: #ffa500 !important;\n  box-shadow: 0 0 20px rgba(255, 162, 0, 0.3) !important;\n}\n\n\n.main-content {\n  flex: 1;\n  padding: 2rem;\n  background-color: #0a0a0a;\n  position: relative;\n  overflow-y: auto;\n}\n\n.main-content::before {\n  content: '';\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: \n    radial-gradient(circle at 20% 50%, rgba(0, 255, 136, 0.05) 0%, transparent 50%),\n    radial-gradient(circle at 80% 50%, rgba(0, 204, 255, 0.05) 0%, transparent 50%);\n  pointer-events: none;\n  z-index: 0;\n}\n\n\n.main-content > * {\n  position: relative;\n  z-index: 1;\n}\n\n@keyframes pulse {\n  0% {\n    box-shadow: 0 0 0 0 rgba(0, 255, 136, 0.4);\n  }\n  70% {\n    box-shadow: 0 0 0 10px rgba(0, 255, 136, 0);\n  }\n  100% {\n    box-shadow: 0 0 0 0 rgba(0, 255, 136, 0);\n  }\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.message {\n  padding: 1rem;\n  border-radius: 8px;\n  margin-bottom: 1rem;\n  animation: slideIn 0.3s ease;\n  font-weight: 500;\n}\n\n.message.success {\n  background: rgba(0, 255, 136, 0.1);\n  border: 1px solid rgba(0, 255, 136, 0.3);\n  color: #00ff88;\n}\n\n.message.error {\n  background: rgba(255, 0, 0, 0.1);\n  border: 1px solid rgba(255, 0, 0, 0.3);\n  color: #ff4444;\n}\n\n.app-footer {\n  background: linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%);\n  border-top: 1px solid #333;\n  padding: 1rem 2rem;\n  margin-top: auto;\n}\n\n.footer-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.club-name {\n  font-weight: 600;\n  background: linear-gradient(135deg, #00ff88 0%, #00ccff 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.created-by {\n  font-size: 0.9rem;\n  color: #888;\n  font-style: italic;\n}\n\n@media (max-width: 768px) {\n  .navbar {\n    flex-direction: column;\n    padding: 1rem;\n    gap: 1rem;\n  }\n\n  .navbar-brand {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .navbar-logo {\n    height: 40px;\n    width: 40px;\n  }\n\n  .navbar h1 {\n    font-size: 1.5rem;\n  }\n\n  .nav-buttons {\n    width: 100%;\n    justify-content: center;\n    flex-wrap: wrap;\n  }\n\n  .nav-buttons button {\n    padding: 0.4rem 1rem;\n    font-size: 0.9rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .navbar-logo {\n    height: 35px;\n    width: 35px;\n  }\n\n  .navbar h1 {\n    font-size: 1.2rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
